

class HeadlineAnalysis {
  constructor(ajaxUrl) {
    this.ajaxUrl = ajaxUrl;
  }

  fetchPage(page, query) {
    var fetch = window.fetch;
    var requestUrl = this.ajaxUrl + '?action=theme:headline-analysis-feed';
    requestUrl += '&page=' + page;
    if (query.length) {
      requestUrl += `&query=${query}`;
    }
    var request = new window.Request(requestUrl);

    return fetch(request)
      .then(function(response) {
        if (response.status === 200) {
          return response.json();
        }
      })
      .then(this.fetchPageComplete);
  }

  fetchPageComplete(response) {
    return (response && response.data) ? response.data : [];
  }
}


var headlineAnalysis = new HeadlineAnalysis(window.SBM.ajaxUrl);


export default headlineAnalysis;

